module.exports = "/packs/010-0af0a1cb5b1757dc029c7ab37a47f3cd.jpg";